import React, { useState } from 'react'

import { useStyles } from './AdresseAutoCompleteStyle'

//Material UI
import Autocomplete, { createFilterOptions } from '@material-ui/lab/Autocomplete'
import TextField from '@material-ui/core/TextField'


export default function AdresseAutoComplete(props) {

  const { value, setValue, required, postCodes, register, nameVille, nameCodePostal } = props
  const classes = useStyles()
  const [code, setcode] = useState(value.code ?? '')

  function onChange(e, v) {
    if (v) {
      setValue(v)
      setcode(v.code)
    }
    else setValue({ nom: '', code: '' })
  }

  function changedInput(e, v) {
    if(v === undefined) v = ''
    if(v !== value.nom) {
      setcode('')
      setValue({ nom: '', code: '' })
    }
  }

  function getLabel(nom, code) {
    if(!nom) return ''
    if(!code) return nom
    return `${nom} (${code})`
  }

  function setCity(code) {
    setcode(code)
    if(code.length < 5) return setValue({ nom: '', code: '' })
    const city = postCodes.find(e => e.code === code)
    if(city) setValue(city)
    else setValue({ nom: '', code: '' })
  }

  return (
    <div className={classes.cityLine}>
      <Autocomplete
        freeSolo

        value={value}
        options={postCodes}
        autoHighlight
        filterSelectedOptions
        getOptionLabel={(option) => getLabel(option.nom, option.code)}
        renderInput={(params) => <TextField
          {...params}
          label="Ville"
          name={nameVille ?? 'ville'}
          variant="outlined"
          required={required}
          inputRef={register({ required: 'Ce champ est requis' })}
          error={value.length < 1}
          helperText={value.length < 1 ? 'Ce champ est requis' : ''}
          onChange={changedInput}

        />}
        noOptionsText="Aucun résultat"
        onChange={onChange}
        filterOptions={createFilterOptions({ limit: 10 })}
      />
      <TextField
        label={'Code postal'}
        variant="outlined"
        type="text"
        name={nameCodePostal ?? 'codePostal'}
        margin="dense"
        value={code}
        inputRef={register({ required: 'Ce champ est requis' })}
        error={code.length < 1}
        helperText={code.length < 1 ? 'Ce champ est requis' : ''}
        onChange={(e) => setCity(e.target.value)}
        required={required}
      />
    </div>
  )
}
